import { render, staticRenderFns } from "./DialogDetallesPlanilla.vue?vue&type=template&id=2156e5cd"
import script from "./DialogDetallesPlanilla.vue?vue&type=script&lang=js"
export * from "./DialogDetallesPlanilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports